import React from 'react';
import { Link } from 'react-router-dom';
import { initials, matchesFilter, sortByLastEdit } from './partnerHome';
import { agoDate, lastEditSub, loginTone } from '../../lib/conciergeActivityModel';
import TilePhoto from '../TilePhoto';

function AthleteTile({ row, now }) {
  // The concierge page 404s a partner on an athlete they have not claimed, so only clients get it.
  const to = row.is_client ? `/athletes/${row.user_id}/concierge` : `/athletes/${row.user_id}`;
  const meta = [row.position_primary, row.graduation_year && `Class of ${row.graduation_year}`, row.school]
    .filter(Boolean);
  const name = row.name || 'Unnamed athlete';
  const sub = lastEditSub(row.last_profile_change_field, row.last_profile_change_by);
  const tone = row.last_login_at ? loginTone(row.last_login_at, now) : 'red';
  return (
    <Link to={to} className="ph-ath" data-testid={`partner_tile_${row.user_id}`}>
      <div className="ph-ath__top">
        {row.photo_thumb
          ? <TilePhoto className="ph-ath__photo" thumb={row.photo_thumb} full={row.photo_url} />
          : <span className="ph-ath__photo ph-ath__photo--initials" aria-hidden="true">{initials(row.name)}</span>}
        <div className="ph-ath__who">
          <div className="ph-ath__name">{name}</div>
          {meta.length > 0 && (
            <div className="ph-ath__meta" data-testid={`partner_meta_${row.user_id}`}>
              {meta.map((seg, i) => (
                <React.Fragment key={i}>
                  {i > 0 && ' '}
                  <span className="ph-ath__seg">{i < meta.length - 1 ? `${seg} ·` : seg}</span>
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="ph-ath__rows">
        <div className="ph-ath__row">
          <span>Last login</span>
          <b className={`ph-ath__v ph-ath__v--${tone}`} data-testid={`partner_login_${row.user_id}`}>
            {row.last_login_at ? agoDate(row.last_login_at, now) : 'Never'}
          </b>
        </div>
        <div className="ph-ath__row">
          <span>Last profile edit</span>
          <b className="ph-ath__v">
            {row.last_profile_change_at ? agoDate(row.last_profile_change_at, now) : 'Never'}
            {sub && <span className="ph-ath__sub">{sub}</span>}
          </b>
        </div>
      </div>
    </Link>
  );
}

export default function PartnerAthleteTiles({ rows, filter, now = new Date() }) {
  const shown = sortByLastEdit(rows.filter((r) => matchesFilter(r, filter, now)));
  let empty = null;
  if (!rows.length) empty = 'No clients yet. Add an athlete to get started.';
  else if (!shown.length) empty = 'No clients match this filter.';
  return (
    <section data-testid="partner_tiles">
      {empty
        ? <p className="adm__card ph-empty">{empty}</p>
        : <div className="ph-athletes">{shown.map((r) => <AthleteTile key={r.user_id} row={r} now={now} />)}</div>}
    </section>
  );
}
